<template>
  <div v-show="showInput">
    <InputString
        style="padding: 10px; width:95%"
        v-bind="inputTextboxProps"
        v-model="inputText"
        ref="componentInput"
    ></InputString>
    <oxygen-button-ribbon ref="selectComponentButtonRibbon" :buttons="selectButtons"></oxygen-button-ribbon>
  </div>
  <div>
    <InputString
        style="padding: 10px; width:95%"
        v-bind="functionFileInputTextboxProps"
        v-model="functionFileInputText"
        ref="functionFileInput"
        @vue:mounted="functionFileInputMounted"
    ></InputString>
    <oxygen-button-ribbon ref="functionFileButtonRibbon" :buttons="functionFileButtons"></oxygen-button-ribbon>
  </div>
  <div style="color: black; margin:5px; font-size:12px; font-weight: bold;">{{component.DisplayName}}</div>
  <div v-show="showEngine">
    <span style="margin-left:5px; color: black;font-size:12px;">AI Engine:</span>
    <span style="margin-left:10px;">
      <select ref="engine" v-model="aiEngine" style="font-size:12px;">
        <option value="openai" selected>OpenAI</option>
        <option value="claude">Claude</option>
      </select>
    </span>
  </div>
  <oxygen-menu-table
      :tableData="conversationTableData"
      ref="menuTable"
      @vue:mounted="tableMounted"
      :active-selection="false"
  ></oxygen-menu-table>
  <InputTextareaString
      is-textarea="true"
      wrap="off"
      ref="textarea"
      v-bind="textareaProps"
      @vue:mounted="textareaMounted"
      v-model="messageBoxText"
      rows="5" cols="50"
      style="width: 100%;border: 0; height: 39px; padding-left: 6px; resize: none; overflow: hidden; background-color: white; font-size:12px; word-wrap: break-word; text-wrap: wrap;"
  ></InputTextareaString>
  <oxygen-button-ribbon ref="buttonRibbon" :buttons="buttons"></oxygen-button-ribbon>
</template>
<script>
import OxygenMenuTable from './../OxygenMenuTable/OxygenMenuTable.vue';
import InputTextareaString from './../InputTextareaString/InputTextareaString.vue';
import OxygenButtonRibbon from './../OxygenButtonRibbon/OxygenButtonRibbon.vue';
import InputString from './../InputString/InputString.vue';
import * as oxygenUtil from './../OxygenUtil/oxygenutil.js';
import * as async from 'async-es';

export default {
  components: {
    OxygenMenuTable,
    InputTextareaString,
    OxygenButtonRibbon,
    InputString
  },
  props: {
    initComponentId: String,
    viewportID: String,
    clientID: String
  },
  created() {
    //console.log('created', 'viewportId:', this.viewportID, ' - viewport:', window.devStore.viewPorts.find(e => e.viewportID === this.viewportID));
    this.viewport = window.devStore.viewPorts.find(e => e.viewportID === this.viewportID).MessageBox;
    //console.log('created', 'comp:', component);
    //this.textareaProps.messageBoxComponent = component;
  },
  data() {
    return {
      showInput: true,
      showEngine: false,
      aiEngine: 'openai',
      component: {
        DisplayName: ''
      },
      inputText: '',
      inputTextboxProps: {
        addValuesToMessageBox: false,
        placeholder: 'Component DisplayName',
        messageBoxComponent: '',
        value: ''
      },
      functionFileInputText: '',
      functionFileInputTextboxProps: {
        addValuesToMessageBox: false,
        placeholder: 'Functions Filepath',
        messageBoxComponent: '',
        value: ''
      },
      componentId: '',
      selectButtons: [],
      functionFileButtons: [],
      buttons: [],
      viewport: {},
      currentDialogues: [],
      currentDialoguesKeys: [],
      textareaProps: {
        placeholder: 'Message',
        messageBoxComponent: '',
        value: ''
      },
      messageBoxText: '',
      conversationTableData: {
        showHeader: false,
        showCheckbox: true,
        showFolder: false,
        showRightMenu: true,
        cols: [
          {
            header: {},
            type: 'html',
            callback: () => {}
          }
        ],
        dataRows: [],
        selectedRows: [],
        root: {
          data: {},
          level: 0
        }
      }
    }
  },
  async mounted() {
    this.createButtons();
    if(this.initComponentId) {
      this.showInput = false;
      this.componentId = this.initComponentId;
      await async.parallel([
        async ()=> {
          await this.populateComponentDialogues(this.componentId);
        }
      ]);
    }
  },
  computed: {
    aiURL() {
      let urls = {
        'openai': '/OxygenAI/OpenAI/CreateChatCompletion',
        'claude': '/OxygenAI/Claude/CreateChatCompletion'
      }
      return urls[this.aiEngine];
    }
  },
  methods: {
    async functionFileInputMounted() {
      this.component = await oxygenUtil.getComponent(this.initComponentId);

      this.functionFileInputText = ( this.component && this.component.InitialContext && this.component.InitialContext.AIDialogueFilepath) || '';
      this.functionFileInputTextboxProps.value =  this.functionFileInputText;
      //console.log('functionFileInputMounted', 'functionFileInputText:', this.functionFileInputText);

      console.log('functionFileInputMounted', 'setting inputVal:', this.functionFileInputText);
      this.$refs.functionFileInput.inputVal = this.functionFileInputText;
    },
    getContent(contentObj) {
      contentObj && Array.isArray(contentObj.content) && (this.aiEngine = 'claude');
      return contentObj ? (Array.isArray(contentObj.content)? contentObj.content[0].text : contentObj.content) : '';
    },
    async populateComponentDialogues(componentId) {
      await this.getCurrentDialogues(componentId);
      this.showEngine = true;
      let j = 0;
      for(let i = 0; i < this.currentDialogues.length; i++) {
        let keyParts = this.currentDialoguesKeys[j++].Key.split('/');
        this.addMenuTableRow(keyParts[keyParts.length - 1], this.getContent(this.currentDialogues[i]),
        ( (i + 1) === this.currentDialogues.length) ? '' : this.getContent(this.currentDialogues[++i]));
      }
    },
    async selectComponent() {
      let component = await oxygenUtil.getComponentByDisplayName(this.$refs.componentInput.$el.value);
      if(component) {
        this.$refs.menuTable.resetTable();
        this.componentId = component.Node;
        Object.assign(this.component, component);
        await this.populateComponentDialogues(component.Node);
        this.inputText = this.$refs.componentInput.$el.value = '';
      }
    },
    createButtons() {
      this.buttons.push(
          { id: 'reset', html: 'Reset', callback: ()=>{
              this.resetButtonClick();
            }, disabled: false, show: true, orientation: 'right', style: { 'background-color': '#0072C5', 'color': 'white'}},
          { id: 'remove', html: 'Remove', callback: ()=>{
              this.removeButtonClick();
            }, disabled: false, show: true, orientation: 'right', style: { 'background-color': '#0072C5', 'color': 'white'}},
          { id: 'save', html: 'User Only', callback: async ()=>{
              this.saveButtonClick();
            }, disabled: false, show: true, orientation: 'right', style: { 'background-color': '#0072C5', 'color': 'white'}},
          { id: 'generate', html: 'Generate', callback: async ()=>{
              this.buttonClick();
            }, disabled: false, show: true, orientation: 'right', style: { 'background-color': '#0072C5', 'color': 'white'}}
      );
      this.selectButtons.push(
          { id: 'select', html: 'Select', callback: async ()=>{
              await this.selectComponent();
            }, disabled: false, show: true, orientation: 'right', style: { 'background-color': '#0072C5', 'color': 'white'}}
      );
      this.functionFileButtons.push(
          { id: 'save', html: 'Save', callback: async ()=>{
              await this.saveFunctionFile();
            }, disabled: false, show: true, orientation: 'right', style: { 'background-color': '#0072C5', 'color': 'white'}}
      )
    },
    addMenuTableRow(path, userText, botText) {
      this.$refs.menuTable.addRow({
        cols: [
          {
            html: `<div style="font-size:12px;margin-top:5px; margin-bottom:5px;font-weight:bold;">User</div><div style="float: left; font-size:12px;">${userText}</div>
${botText ?  `<div style="font-size:12px;margin-top:5px; margin-bottom:5px;font-weight:bold;">AI</div><div style="float:right;font-size:12px;">${botText}</div>` : ''}`,
            styleObj: {}
          }
        ],
        data: {
          userText,
          botText
        },
        path,
        show: true
      });
    },
    async getCurrentDialogues(componentId) {
      let dialoguesObj = await oxygenUtil.callCommonServiceAPI("simplia-api", "getOxygenAIDialogues", { componentId });
      this.currentDialogues = dialoguesObj.dialogues;
      this.currentDialoguesKeys = dialoguesObj.list;
    },
    async removeButtonClick() {
      let selectedRows = this.$refs.menuTable.getSelectedRows();
      if(selectedRows.length) {
        async.each(selectedRows, async (row)=>{

          await oxygenUtil.callCommonServiceAPI("simplia-api", "removeOxygenAIDialogue", { componentId: this.componentId, type: "component", key: row.path });
          this.$refs.menuTable.deleteRow(row.path);
        });
        await this.getCurrentDialogues(this.componentId);
      }
    },
    async saveFunctionFile() {
      await oxygenUtil.updateComponentEx(this.componentId, { 'set': {
          'InitialContext.AIDialogueFilepath': this.$refs.functionFileInput.$el.value
        }})
    },
    async resetButtonClick() {
      await oxygenUtil.callCommonServiceAPI("simplia-api", "removeOxygenAIDialogueFull", { componentId: this.componentId, type: "component",
        keys: this.$refs.menuTable.tableData.dataRows.map(e => e.path) });
      this.$refs.menuTable.resetTable();
      this.currentDialogues = [];
    },
    async saveButtonClick() {
      let storedData = await this.storeAIDialogue(this.componentId, [ this.formatCurrentUserMessage()] );
      let splitKey = storedData.key.split('/');
      this.addMenuTableRow(splitKey[splitKey.length - 1], this.messageBoxText);
      this.messageBoxText = this.$refs.textarea.inputVal = '';
    },
    async buttonClick() {
      try  {
        let dialogueObj = await async.waterfall([
          async () => {
            let reply = await this.sendAIChatMessages();
            console.log('buttonClick', 'reply:', reply);
            return [ this.formatCurrentUserMessage(), reply];
          },
          async (dialogue) => {
            let storedData = await this.storeAIDialogue(this.componentId, dialogue);
            return { dialogue, key: storedData.key } ;
          }
        ]);

        let splitKey = dialogueObj.key.split('/');
        this.addMenuTableRow(splitKey[splitKey.length - 1], this.getContent(dialogueObj.dialogue[dialogueObj.dialogue.length - 2]), this.getContent(dialogueObj.dialogue[dialogueObj.dialogue.length - 1]));
        this.messageBoxText = this.$refs.textarea.inputVal = '';
      }
      catch(e) {
        console.log('Error:', e);
      }
    },
    tableMounted() {

    },
    textareaMounted() {

    },
    async storeAIDialogue(componentId, dialogue) {
      this.currentDialogues.concat(dialogue);
      return await oxygenUtil.callCommonServiceAPI("simplia-api", "storeOxygenAIDialogue", { type: "component", componentId, dialogue })
    },
    formatCurrentUserMessage() {
      return {role: 'user', content: this.messageBoxText};
    },
    async sendAIChatMessages() {
      let url = this.aiURL,
          data = {
            messages: [].concat(
                this.currentDialogues || [],
                this.formatCurrentUserMessage())
          };
      let response = await fetch(
          url,
          {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            mode: 'cors'
          }
      ).catch((e) => {
        throw e;
      });

      let responseObj;
      if(response.ok && (responseObj = await response.json())) {
        console.log('sendAIChatMessages', 'response:', responseObj);
        return responseObj;
      }
    }
  },
  watch: {
  }
}
</script>
<style>
textarea:focus {
  outline: 0;
}

.dhx_button--view_flat.dhx_button--color_primary {
  background-color: #0072C5;
  outline-width: 0;
}

.dhx_button--view_flat {
  display: -webkit-box;
  display: flex;
  -webkit-box-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  align-items: center;
  font-family: Roboto,Arial,Tahoma,Verdana,sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  text-align: center;
  color: #fff;
  -webkit-transition: background-color .2s ease-in,color .2s ease-in,box-shadow .2s ease-in;
  transition: background-color .2s ease-in,color .2s ease-in,box-shadow .2s ease-in;
}

.dhx_button--size_medium {
  padding: 6px 16px;
  text-transform: uppercase;
  line-height: 20px;
}

.dhx_button {
  overflow: visible;
  position: relative;
  text-decoration: none;
  background-image: none;
  border: 0;
  touch-action: manipulation;
  -webkit-appearance: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  white-space: nowrap;
  cursor: pointer;
}

.dhx_button--view_flat {
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: Roboto,Arial,Tahoma,Verdana,sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  text-align: center;
  color: #fff;
  transition: background-color .2s ease-in,color .2s ease-in,box-shadow .2s ease-in;
}

textarea::placeholder {
  padding-top: 12px;
}
</style>